@if (block.data.type === 'Image/Text') {
    <div class="call-to-action-image-text" [ngClass]="{ 'call-to-action-image-text--flipped': !block.data.flipped }">
        <div class="call-to-action-{{ blockType }}__content">
            @if (block.data.title) {
                <h2 [innerHTML]="block.data.title" class="call-to-action-{{ blockType }}__heading"></h2>
            }
            @if (block.data.text) {
                <div [innerHTML]="block.data.text" class="call-to-action__paragraph"></div>
            }
            @if (block.data.url && !block.data.url.includes('http') && !block.data.url.includes('/file/')) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [routerLink]="block.data.url"
                    [target]="block.data.externalLink ? '_blank' : '_self'"
                    class="btn btn-primary btn--icon mb-0 align-self-start">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
            @if (block.data.url && (block.data.url.includes('http') || block.data.url.includes('/file/'))) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [href]="block.data.url"
                    class="btn btn-primary btn--icon mb-0 align-self-start"
                    target="_blank">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
        </div>
        @if (backgroundImage) {
            <div
                [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"
                class="call-to-action-{{ blockType }}__image call-to-action__image--{{ block.uid }}"></div>
        }
    </div>
}
@if (block.data.type === 'Text Only') {
    <div class="call-to-action-text-only">
        <div class="call-to-action-{{ blockType }}__content">
            @if (block.data.title) {
                <h2 [innerHTML]="block.data.title" class="call-to-action-{{ blockType }}__heading"></h2>
            }
            @if (block.data.text) {
                <div [innerHTML]="block.data.text" class="call-to-action__paragraph"></div>
            }
            @if (block.data.url && !block.data.url.includes('http') && !block.data.url.includes('/file/')) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [routerLink]="block.data.url"
                    [target]="block.data.externalLink ? '_blank' : '_self'"
                    class="btn btn-primary btn--icon mb-0 align-self-start">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
            @if (block.data.url && (block.data.url.includes('http') || block.data.url.includes('/file/'))) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [href]="block.data.url"
                    class="btn btn-primary btn--icon mb-0 align-self-start"
                    target="_blank">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
        </div>
    </div>
}
@if (block.data.type === 'Icon') {
    <div
        class="call-to-action-icon"
        [ngStyle]="{
            'background-color':
                block.data.backgroundColor === 'White'
                    ? '#ffffff'
                    : block.data.backgroundColor === 'Blue'
                      ? '#f0f4ff'
                      : '#fff',
        }">
        <div class="call-to-action-{{ blockType }}__content">
            @if (block.data.image_url) {
                <div class="call-to-action-{{ blockType }}__image call-to-action__image--{{ block.uid }}">
                    <img [src]="block.data.image_url" [alt]="block.data.image_alt || block.data.title" />
                </div>
            }
            @if (block.data.title) {
                <h2 [innerHTML]="block.data.title" class="call-to-action-{{ blockType }}__heading"></h2>
            }
            @if (block.data.text) {
                <div [innerHTML]="block.data.text" class="call-to-action__paragraph"></div>
            }
            @if (block.data.url && !block.data.url.includes('http') && !block.data.url.includes('/file/')) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [routerLink]="block.data.url"
                    [target]="block.data.externalLink ? '_blank' : '_self'"
                    class="btn btn-primary btn--icon mb-0 align-self-start">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
            @if (block.data.url && (block.data.url.includes('http') || block.data.url.includes('/file/'))) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [href]="block.data.url"
                    class="btn btn-primary btn--icon mb-0 align-self-start"
                    target="_blank">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
        </div>
    </div>
}
@if (block.data.type === 'Quote') {
    <div class="call-to-action-quote" [ngClass]="{ 'call-to-action-quote--flipped': !block.data.flipped }">
        <div class="call-to-action-{{ blockType }}__content">
            @if (block.data.title) {
                <h2 [innerHTML]="block.data.title" class="call-to-action-{{ blockType }}__heading"></h2>
            }
            @if (block.data.text) {
                <div [innerHTML]="block.data.text" class="call-to-action__paragraph"></div>
            }
            @if (block.data.url && !block.data.url.includes('http') && !block.data.url.includes('/file/')) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [routerLink]="block.data.url"
                    [target]="block.data.externalLink ? '_blank' : '_self'"
                    class="btn btn-primary btn--icon mb-0 align-self-start">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
            @if (block.data.url && (block.data.url.includes('http') || block.data.url.includes('/file/'))) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [href]="block.data.url"
                    class="btn btn-primary btn--icon mb-0 align-self-start"
                    target="_blank">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
        </div>
        @if (backgroundImage) {
            <div
                [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"
                class="call-to-action-{{ blockType }}__image call-to-action__image--{{ block.uid }}"></div>
        }
    </div>
}
@if (block.data.type === 'Stats') {
    <div class="call-to-action-stats" [ngClass]="{ 'call-to-action-stats--flipped': !block.data.flipped }">
        <div class="call-to-action-{{ blockType }}__content">
            @if (block.data.title) {
                <h2 [innerHTML]="block.data.title" class="call-to-action-{{ blockType }}__heading"></h2>
            }
            @if (block.data.text) {
                <div [innerHTML]="block.data.text" class="call-to-action__paragraph"></div>
            }
            @if (block.data.url && !block.data.url.includes('http') && !block.data.url.includes('/file/')) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [routerLink]="block.data.url"
                    [target]="block.data.externalLink ? '_blank' : '_self'"
                    class="btn btn-primary btn--icon mb-0 align-self-start">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
            @if (block.data.url && (block.data.url.includes('http') || block.data.url.includes('/file/'))) {
                <a
                    [attr.aria-label]="'Learn more about ' + block.data.title"
                    [href]="block.data.url"
                    class="btn btn-primary btn--icon mb-0 align-self-start"
                    target="_blank">
                    <ng-container *ngTemplateOutlet="link"></ng-container>
                </a>
            }
        </div>
        @if (backgroundImage) {
            <div
                [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"
                class="call-to-action-{{ blockType }}__image call-to-action__image--{{ block.uid }}"></div>
        }
    </div>
}
<ng-template #link>
    <span [innerText]="block.data.buttonText" class="me-2"></span>
    <svg viewBox="0 0 15 13" width="100%">
        <defs>
            <path
                [attr.id]="'svg-id-' + block.uid"
                d="M317.745 266.879l-5.58-5.622a.867.867 0 0 0-1.233 0c-.34.343-.34.9 0 1.242l4.091 4.123h-11.091c-.481 0-.932.393-.932.878s.45.878.932.878h11.091l-4.09 4.123c-.341.343-.341.899 0 1.242a.866.866 0 0 0 1.232 0l5.58-5.622c.34-.343.34-.9 0-1.242z" />
        </defs>
        <use
            [attr.fill]="
                block.data.arrowColor ? block.data.arrowColor : 'linear-gradient(315deg, #BC40E1 0%, #3178E0 100%)'
            "
            [attr.xlink:href]="'#svg-id-' + block.uid"
            fill-rule="nonzero"
            transform="translate(-303 -261)" />
    </svg>
</ng-template>
